import { slice } from '../slices';

const nameSpace = slice.name;

export const accountSelector = (state$) => state$[nameSpace].account;
export const menuSelector = (state$) => state$[nameSpace].menu;
export const accountOptionsSelector = (state$) => state$[nameSpace].accountOptions;
export const storedInHouseMenuSettingsSelector = (state$) => state$[nameSpace].storedInHouseMenuSettings;
export const selectedAnalyticSelector = (state$) => state$[nameSpace].selectedAnalytic;
export const publisherNameSelector = (state$) => state$[nameSpace].publisherName;
export const salesforceIdSelector = (state$) => state$[nameSpace].salesforceId;
export const isLoadingUrlSelector = (state$) => state$[nameSpace].isLoadingUrl;
export const lookerReportUrlSelector = (state$) => state$[nameSpace].lookerReportUrl;
export const statusOverallFailureSelector = (state$) => state$[nameSpace].statusOverallFailure;
export const statusShowPopupSelector = (state$) => state$[nameSpace].statusShowPopup;
export const statusPopupMessageSelector = (state$) => state$[nameSpace].statusPopupMessage;
